/**
 * Shim for MockCheckoutService to exclude it from checkout bundle
 * This service is only used in the page builder editor mode, not in actual checkout
 */

// Empty stub class that matches the MockCheckoutService interface
// All methods throw errors since they should never be called in checkout
export class MockCheckoutService {
  setContactInfo = async () => {
    throw new Error('MockCheckoutService not available in checkout bundle');
  };

  setShippingMethod = async () => {
    throw new Error('MockCheckoutService not available in checkout bundle');
  };

  sendCapiToServer = async () => {
    throw new Error('MockCheckoutService not available in checkout bundle');
  };

  setShippingAddress = async () => {
    throw new Error('MockCheckoutService not available in checkout bundle');
  };

  checkoutStart = async () => {
    throw new Error('MockCheckoutService not available in checkout bundle');
  };

  checkoutComplete = async () => {
    throw new Error('MockCheckoutService not available in checkout bundle');
  };

  getPreCheckoutUpSells = async () => {
    throw new Error('MockCheckoutService not available in checkout bundle');
  };

  getPostCheckoutUpSells = async () => {
    throw new Error('MockCheckoutService not available in checkout bundle');
  };

  getPostCheckoutUpSellsV2 = async () => {
    throw new Error('MockCheckoutService not available in checkout bundle');
  };

  checkoutUpdateItems = async () => {
    throw new Error('MockCheckoutService not available in checkout bundle');
  };

  checkoutAddItem = async () => {
    throw new Error('MockCheckoutService not available in checkout bundle');
  };

  postUpsellPurchase = async () => {
    throw new Error('MockCheckoutService not available in checkout bundle');
  };

  CreateUpsellCart = async () => {
    throw new Error('MockCheckoutService not available in checkout bundle');
  };

  checkoutApplyDiscountCode = async () => {
    throw new Error('MockCheckoutService not available in checkout bundle');
  };

  getCountriesList = async () => {
    throw new Error('MockCheckoutService not available in checkout bundle');
  };

  getUpsellAndOrderDetails = async () => {
    throw new Error('MockCheckoutService not available in checkout bundle');
  };

  getStoreDetails = async () => {
    throw new Error('MockCheckoutService not available in checkout bundle');
  };

  getDetailsStore = async () => {
    throw new Error('MockCheckoutService not available in checkout bundle');
  };

  fetchVisitorLocation = async () => {
    throw new Error('MockCheckoutService not available in checkout bundle');
  };

  getCheckout = async () => {
    throw new Error('MockCheckoutService not available in checkout bundle');
  };

  subscribeToNewsLetter = async () => {
    throw new Error('MockCheckoutService not available in checkout bundle');
  };

  getCheckoutPageByStoreID = async () => {
    throw new Error('MockCheckoutService not available in checkout bundle');
  };

  getPageById = async () => {
    throw new Error('MockCheckoutService not available in checkout bundle');
  };

  getFunnelishPageById = async () => {
    throw new Error('MockCheckoutService not available in checkout bundle');
  };

  getCartDetails = async () => {
    throw new Error('MockCheckoutService not available in checkout bundle');
  };

  getPixel = async () => {
    throw new Error('MockCheckoutService not available in checkout bundle');
  };

  getAllStoreProducts = async () => {
    throw new Error('MockCheckoutService not available in checkout bundle');
  };

  getTemplateById = async () => {
    throw new Error('MockCheckoutService not available in checkout bundle');
  };

  updateTemplate = async () => {
    throw new Error('MockCheckoutService not available in checkout bundle');
  };

  getPreviewData = async () => {
    throw new Error('MockCheckoutService not available in checkout bundle');
  };

  doMerchantValidation = async () => {
    throw new Error('MockCheckoutService not available in checkout bundle');
  };

  applePayLog = async () => {
    throw new Error('MockCheckoutService not available in checkout bundle');
  };

  doVGSDecrypt = async () => {
    throw new Error('MockCheckoutService not available in checkout bundle');
  };

  getAllFunnelishConfig = async () => {
    throw new Error('MockCheckoutService not available in checkout bundle');
  };

  saveFunnelishProducts = async () => {
    throw new Error('MockCheckoutService not available in checkout bundle');
  };

  createFunnelishConfig = async () => {
    throw new Error('MockCheckoutService not available in checkout bundle');
  };

  sendOrderDetails = async () => {
    throw new Error('MockCheckoutService not available in checkout bundle');
  };

  swapCartProduct = async () => {
    throw new Error('MockCheckoutService not available in checkout bundle');
  };
}
